export default __webpack_public_path__ + "static/735-7c2cf8650fd1f0489d89fb6d0e11ed10.gif";